import t from './translateUtil';
import i18next from 'i18next';
import moment from 'moment';
import creditCardType, { getTypeInfo, types as CardType } from 'credit-card-type';
//constants definition
export {
    initHistory,
    getHistory,
    diffDateInMinute,
    cloneObject,
    isValidEmail,
    getKeyAuthorizationBasic,
    isRetina,
    startCountDown,
    stopCountDown,
    formatNumToMMss,
    maskPhone,
    maskEmail,
    validPhoneNumber
}

var timezone = 2; 

var _history = '';
function initHistory(propsHistory) {
    _history = propsHistory;
}

function getHistory() {
    return _history;
}

function formatNumToMMss(totalSec) {
    let min = Math.floor(totalSec / 60) + '';
    let sec = totalSec % 60 + '';
    return (pad(min, 2, '0') + ':' + pad(sec, 2, '0'));
}
function diffDateInMinute(date1, date2) {
    var firstDate = new Date(date1);
    var comparedDate = new Date(date2);//"2015-12-03T06:52:11.597Z"
    return Math.round((firstDate - comparedDate) / (60 * 1000));
}

function diffDateInSecond(date1, date2) {
    var firstDate = new Date(date1);
    var comparedDate = new Date(date2);//"2015-12-03T06:52:11.597Z"
    return Math.round((firstDate - comparedDate) / (1000));
}

function cloneObject(obj) {
    if (!obj)
        return obj;
    return JSON.parse(JSON.stringify(obj))
}

function convertArrayToString(array) {
    var str = '';
    if (array && array.length > 0) {
        console.log("array:", array);
        array.forEach(element => {
            str = str + element + ',';
        });
        str = str.trim().substring(0, str.length - 1);
    }
    console.log("strrrrrrrrrrrr:", str);
    return str;
}

function isValidEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(email))
        return true;
    else
        return false;

}
function validPhoneNumber(number){

    var re = /^([0-9])+$/;
    if (re.test(number))

        return true;
    else
        return false;
}
function getKeyAuthorizationBasic({ username, password }) {
    var key = btoa(username + ":" + password).toUpperCase();
    return key
}

function isRetina(first, second) {
    if (window.devicePixelRatio >= 2) {
        return second
    }
    return first;
};
export function formatDateToDDMMYYYYHHSSFrEpoch(epochTime) {
    var d = new Date(epochTime * 1000); // The 0 there is the key, which sets the date to the epoch
    return formatDateTimeToMonthNameAndDayOfWeek(d);
}
export function formatDateTimeToMonthNameAndDayOfWeek(date) {
    var date = new Date(date);
    var dayOfWeeks = createShortDayOfWeek();
    var dayOfWeek = dayOfWeeks[date.getDay()];

    return dayOfWeek + '. ' + formatDateTimeToShortMonthName(date);
}

export function formatDateTimeToShortMonthName(date,withSecond) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth();
    if (day < 10) day = '0' + day;
    var months = createShortMonth();
    month = months[month];
    var hours = date.getHours()
    var minutes = date.getMinutes();
    var second = date.getSeconds();
    if (hours < 10) hours = '0' + hours;
    if (minutes < 10) minutes = '0' + minutes;
    if (second < 10) second = '0' + second;
    var time = hours + ":" + minutes 
    if(withSecond)
        time = time +  ":" + second;
    var dateFormatted = day + ' ' + month + ' ' + date.getFullYear() + " " + time;
    return dateFormatted;
}
export function formatDateToDDMMYYYYFrEpoch(epochTime,normal) {
    var d = new Date(epochTime * 1000); // The 0 there is the key, which sets the date to the epoch
    return normal ? formatDateToDDMMYYYY(d) : formatDateToMonthNameAndDayOfWeek(d);;
}
export function formatDateToDDMMYYYY(date) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth() + 1;
    if (day < 10) day = '0' + day;
    if (month < 10) month = '0' + month;
    var dateFormatted = day + '/' + month + '/' + date.getFullYear();
    return dateFormatted;
}
export function toDateDDMMYYYY({ year, month, day }) {
    if (day < 10) day = '0' + day;
    if (month < 10) month = '0' + month;
    var dateFormatted = day + '/' + month + '/' + year;
    return dateFormatted;
}
export function formatTimeFrEpoch(epochTime) {
    var d = new Date(epochTime * 1000); // The 0 there is the key, which sets the date to the epoch
    return getTime(d);
}
export function getTime(dateTime) {
    var date = new Date(dateTime);
    var hours = date.getHours()
    var minutes = date.getMinutes();
    var second = date.getSeconds();
    if (hours < 10) hours = '0' + hours;
    if (minutes < 10) minutes = '0' + minutes;
    if (second < 10) second = '0' + second;
    var time = hours + ":" + minutes;
    return time;
}
export function formatDateTimeFrEpoch(epochTime) {
    var d = new Date(epochTime * 1000); // The 0 there is the key, which sets the date to the epoch
    // d = getDateTimeLocalUTC(d);
    return formatDateTime(d);
}
export function formatDateTime(dateTime) {
    var date = new Date(dateTime);
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var hours = date.getHours()
    var minutes = date.getMinutes();
    var second = date.getSeconds();

    if (day < 10) day = '0' + day;
    if (month < 10) month = '0' + month;
    if (hours < 10) hours = '0' + hours;
    if (minutes < 10) minutes = '0' + minutes;
    if (second < 10) second = '0' + second;
    var time = hours + ":" + minutes + ":" + second;
    var dateFormatted = day + '/' + month + '/' + date.getFullYear() + " " + time;

    return dateFormatted;
}


export function getDateTimeLocalUTC(date) {
    try {
        var timeZoneOffset = new Date().getTimezoneOffset();
        if (date) {
            var dateUTC = new Date(date).getTime() + timeZoneOffset * 60 * 1000;
            return new Date(dateUTC);
        } else {
            return date;
        }
    } catch (ex) {
        console.log("getDateTimeLocalUTC error:", ex, date);
        return date;
    }
}

export function epochToLocalUTC(epochTime) {
    var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
    d.setUTCSeconds(epochTime);
    d = getDateTimeLocalUTC(d);
    return d;
}

export function getCurrentTimeUTC() {
    let d = new Date();
    return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds());
}

export function calculateDistanceTimeFrEpoch(epochTime) {
    var createdDate = new Date(epochTime * 1000)

    var delta = Math.abs(Date.now() - createdDate) / 1000;

    var week = Math.floor(delta / (86400 * 7));

    var days = Math.floor(delta / 86400);

    var hours = Math.floor(delta / 3600) % 24;

    var minutes = Math.floor(delta / 60) % 60;
    if (week > 1) {
        return formatDateToMonthName(createdDate);
    } else if (week == 1) {
        return '1 week ago';
    } else if (days > 0) {
        if (days == 1)
            return '1 day ago';
        return days + ' days ago';
    } else if (hours > 0) {
        if (hours == 1)
            return '1 hour ago';
        return hours + ' hours ago ';
    } else {
        if (minutes == 1)
            return '1 minute ago'
        return minutes + ' minutes ago';
    }
}


export function formatDateToMonthName(date) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth();
    if (day < 10) day = '0' + day;
    var months = createFulltMonth();
    month =  t(months[month]);
    
    var dateFormatted = day + ' ' + month + ' ' + date.getFullYear();
    return dateFormatted;
}
export function formatDateToShortMonthName(date) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth();
    if (day < 10) day = '0' + day;
    var months = createShortMonth();
    month = months[month];
    var dateFormatted = day + ' ' + month + ' ' + date.getFullYear();
    return dateFormatted;
}
export function formatDateToMonthNameAndDayOfWeek(date) {
    var date = new Date(date);
    var dayOfWeeks = createShortDayOfWeek();
    var dayOfWeek = dayOfWeeks[date.getDay()];

    return dayOfWeek + '. ' + formatDateToShortMonthName(date);
}


export function createMonth() {
    let months = [
        'Jan'
        , 'Feb'
        , 'Mar'
        , 'Apr'
        , 'May'
        , 'Jun'
        , 'Jul'
        , 'Aug'
        , 'Sep'
        , 'Oct'
        , 'Nov'
        , 'Dec'
    ];
    return months;
}
export function createFulltMonth() {
    var month =  i18next.t('MONTH',{ returnObjects: true});
    let months = [
        month.JAN,
        month.FEB,
        month.MAR,
        month.APR,
        month.MAY,
        month.JUN,
        month.JUL,
        month.AUG,
        month.SEP,
        month.OCT,
        month.NOV,
        month.DEC,
    ];
    return months;
}
export function createDayOfWeek() {
    let days = [
        'Mon'
        , 'Tue'
        , 'Wed'
        , 'Thu'
        , 'Fri'
        , 'Sat'
        , 'Sun'
    ];
    return days;
}

export function createDayObj() {
    let days = [];
    for (let k = 1; k < 32; k++) {
        days.push(k);
    }
    return days;
}

export function groupBy(list, keyGetter) {
    customGroupBy(list);
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    console.log('groupBy    ', map);
    return map;
}

export function groupAndSortTran(data){
    console.log('DDDDdatatat   groupAndSortTran   ', data);
    var list = [];
    var transactions = customGroupBy(data);
    transactions.sort(function (a, b) {
        return b[0] - a[0];
    });
    transactions.forEach(function(element, i){
        element[0] = formatDateToMonthNameAndDayOfWeek(element[0]);
        list.push(
            element
        );
    });
    return transactions;
}
export function customGroupBy(data) {
    const res = data.reduce((acc, curr) => {
        if(!acc[curr.performed_on]) acc[curr.performed_on] = []; //If this type wasn't previously stored
        acc[curr.performed_on].push(curr);
        return acc;
      },{});
    var result = Object.keys(res).map(function(key) {
        var year = key.substring(key.length-4, key.length);
        var month = key.substring(key.length-7, key.length-5) -1
        var day = key.substring(0, key.length-8);
        var d = new Date(year, month, day);
        return [d, res[key]];
    });
    return result;
}


//select timer from timersSet
function startCountDown(timer, callbackFn, oldTimer) {
    stopCountDown(timer);
    if (oldTimer)
        stopCountDown(oldTimer);
    timer.countDown = timer.fromVal;
    timer.timerInstance = setInterval(() => {
        if (timer.countDown <= 0) {
            stopCountDown(timer);
            if (oldTimer)
                stopCountDown(oldTimer);
        }
        else {
            timer.countDown = timer.countDown - timer.decreaseVal;
            if (timer.countDown < 0)
                timer.countDown = 0;
            callbackFn(timer.countDown);
        }
        //console.log(timer.name + ':' + timer.countDown)
    }, timer.interval);
}

function stopCountDown(timer) {
    if (timer) {
        clearInterval(timer.timerInstance);
        timer.timerInstance = undefined;
        timer.countDown = 0;
    }
}

export const timersSet = {
    otp_card_registration: {
        name: 'OTP_CARD_REGISTRATION',
        interval: 1000, //in millisecond - 1 second 
        fromVal: 40, // in seconds 
        decreaseVal: 1,
        intervalInstance: undefined
    },
}

function pad(val, len, char, padLeft = true) {
    if (!val)
        return val;
    if (val.length >= len)
        return val;
    let str = val;
    for (let i = 0; i < len - val.length; i++) {
        if (padLeft)
            str = char + str;
        else
            str = str + char;
    }
    return str;
}

function maskEmail(email) {
    if(email){
        var index = email.lastIndexOf("@");
        var prefix = email.substring(0, index);
        var postfix = email.substring(index);
    
        var mask = prefix.split('').map(function (o, i) {
            if (i == 0 || i == (index - 1)) {
                return o;
            } else {
                return '*';
            }
        }).join('');
    
        email = mask + postfix;
    }

    return email;
}

function maskPhone(phone){
    if (phone){
        let strToReplace = phone.substr(2, phone.length).length - 2;
        if(strToReplace){
            phone = phone.substr(0,2) + "*".repeat(strToReplace) + phone.substr(phone.length - 2,phone.length);
        }
    }

    return phone;
}
export function createShortDayOfWeek() {

    var day =  i18next.t('SHORTDAYS',{ returnObjects: true});
    let days = [
        day.SUNDAY,
        day.MONDAY,
        day.TUESDAY,
        day.WEDNESDAY,
        day.THURSDAY,
        day.FRIDAY,
        day.SATURDAY,
    ];
    return days;
}
export function createShortMonth() {
    var month =  i18next.t('SHORTMONTH',{ returnObjects: true});
    let months = [
        month.JAN,
        month.FEB,
        month.MAR,
        month.APR,
        month.MAY,
        month.JUN,
        month.JUL,
        month.AUG,
        month.SEP,
        month.OCT,
        month.NOV,
        month.DEC,
    ];

    return months;
}

export function newGUID() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    //return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    //  s4() + '-' + s4() + s4() + s4();
    return s4() + s4() + s4() + s4() +
        s4() + s4() + s4() + s4();
}

export function getCardType(value) {
    var type = null;
    if (value) {
        var ambiguousCards = creditCardType(value);
        if (ambiguousCards && ambiguousCards.length > 0)
            type = ambiguousCards[0].niceType;
    }
    return type;
}

export function clearNumber(value = '') {
    return value.toString().replace(/\D+/g, '')
}

export function formatParseReplaceSpace(value = '') {
    return value.replace(/\s/g, '')
}

export function formatCreditCardNumber(value) {
    if (!value) {
        return value
    }

    const clearValue = clearNumber(value);
    const issuer = getCardType(value);
    let nextValue

    switch (issuer) {
        case 'amex':
            nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
                4,
                10
            )} ${clearValue.slice(10, 15)}`
            break
        case 'dinersclub':
            nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
                4,
                10
            )} ${clearValue.slice(10, 14)}`
            break
        default:
            nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
                4,
                8
            )} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`
            break
    }

    return nextValue.trim()
}

export const getPeriodDate = (period) => {
	let date = null

	if(period)
	{
		switch (period.toUpperCase()) {
			case dateRangePeriod.START_OF_TODAY:
				date = moment().hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_TODAY:
				date = moment().hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_YESTERDAY:
				date = moment().add(-1, 'day').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_YESTERDAY:
				date = moment().add(-1, 'day').hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_TOMORROW:
				date = moment().add(1, 'day').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_TOMORROW:
				date = moment().add(1, 'day').hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_THIS_WEEK:
				date = moment().startOf('week').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_THIS_WEEK:
				date = moment().endOf('week').hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_THIS_MONTH:
				date = moment().startOf('month').hour(0).second(0).minute(0).toDate();
				break;
			case dateRangePeriod.END_OF_THIS_MONTH:
				date = moment().endOf('month').hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_THIS_YEAR:
				date = moment().startOf('year').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_THIS_YEAR:
				date = moment().endOf('year').hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_THIS_HOUR:
				date = moment().minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_THIS_HOUR:
				date = moment().minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_LAST_WEEK:
				date = moment().add(-1, 'week').startOf('week').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_LAST_WEEK:
				date = moment().add(-1, 'week').endOf('week').hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_LAST_MONTH:
				date = moment().add(-1, 'month').startOf('month').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_LAST_MONTH:
				date = moment().add(-1, 'month').endOf('month').hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_NEXT_WEEK:
				date = moment().add(1, 'week').startOf('week').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_NEXT_WEEK:
				date = moment().add(1, 'week').endOf('week').hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_NEXT_MONTH:
				date = moment().add(1, 'month').startOf('month').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_NEXT_MONTH:
				date = moment().add(1, 'month').endOf('month').hour(23).minute(59).second(59).toDate();
				break;
			case dateRangePeriod.START_OF_FIVE_MONTHS_AGO:
				date = moment().add(-5, 'month').startOf('month').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.START_OF_LAST_YEAR:
				date = moment().add(-1, 'year').startOf('year').hour(0).minute(0).second(0).toDate();
				break;
			case dateRangePeriod.END_OF_LAST_YEAR:
				date = moment().add(-1, 'year').endOf('year').hour(23).minute(59).second(59).toDate();
				break;
			default:
				break;
		}
	}

	return date;
}

export const formatPeriodDate = (date) => {
    return Math.floor(date.getTime() / 1000.0);
}

export const dateRangePeriod = {
	START_OF_TODAY: 'START_OF_TODAY',
	END_OF_TODAY: 'END_OF_TODAY',
	START_OF_THIS_MONTH: 'START_OF_THIS_MONTH',
	END_OF_THIS_MONTH: 'END_OF_THIS_MONTH',
	START_OF_THIS_YEAR: 'START_OF_THIS_YEAR',
	END_OF_THIS_YEAR: 'END_OF_THIS_YEAR',
	START_OF_LAST_MONTH: 'START_OF_LAST_MONTH',
	END_OF_LAST_MONTH: 'END_OF_LAST_MONTH',
	START_OF_LAST_YEAR: 'START_OF_LAST_YEAR',
	END_OF_LAST_YEAR: 'END_OF_LAST_YEAR'
}

export const statementPeriodOption = {
	THIS_MONTH: "THIS_MONTH",
	LAST_MONTH: "LAST_MONTH",
	THIS_YEAR: "THIS_YEAR",
	LAST_YEAR: "LAST_YEAR",
	SPECIFIC_PERIOD:  "SPECIFIC_PERIOD"
}
